export class OtpAlreadyGeneratedException extends Error {
  constructor(message) {
    super(message);
  }
}